import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgControl, Validator } from '@angular/forms';
import { CustomFormControl } from '../custom-form-control.component';
import { InputType } from '../custom-form-control.models';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss', '../../styles/custom-control.styles.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
})
export class InputComponent extends CustomFormControl implements OnInit, ControlValueAccessor, Validator {
  @Input() label: string;
  @Input() type: InputType = 'text';
  @Input() forceDisable: boolean;

  constructor(inj: Injector) {
    super(inj);
  }

  ngOnInit(): void {
    this.initBase();
  }

  selectedValue: any = null;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.applyDisabledState(isDisabled);
  }

  selectValue(data: any): void {
    const rawValue = data.currentTarget.value;
    if (this.type === 'number') {
      this.selectedValue = rawValue ? parseFloat(rawValue) : null;
    } else {
      this.selectedValue = rawValue;
    }

    this.onChange(this.selectedValue); // Notify Angular Forms
    this.onTouched(); // Mark as touched
  }

  registerOnValidatorChange?(fn: () => void): void {}
}
